"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IntlTelInput = _interopRequireDefault(require("./components/IntlTelInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _IntlTelInput.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-intl-tel-input/dist/index.js
// module id = 684
// module chunks = 2